var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('i',{staticClass:"icon icon-spinner delayed-loader"}):_c('span',[_vm._v(_vm._s(_vm.restarts))])
}
var staticRenderFns = []

export { render, staticRenderFns }